import {BaseCurrencyCode} from '@raison/types';
import {combineReducers} from 'redux';
import {stablecoins} from '~/config';
import {Assets} from '~/shared/api/legacy_services/Assets/Assets';
import {appLocalStorage} from '~/shared/persistence';
import {assetsRequestRoutine, setCurrentCurrency} from './assetsActions';

type AssetsAction =
    | ReturnType<typeof assetsRequestRoutine.success>
    | ReturnType<typeof assetsRequestRoutine.failure>
    | ReturnType<typeof assetsRequestRoutine.trigger>;

function fetching(state = false, action: AssetsAction) {
    switch (action.type) {
        case assetsRequestRoutine.trigger.type:
            return true;
        case assetsRequestRoutine.success.type:
        case assetsRequestRoutine.failure.type:
            return false;
        default:
            return state;
    }
}

function assets(state: Assets | null = null, action: AssetsAction): Assets | null {
    switch (action.type) {
        case assetsRequestRoutine.success.type:
            return filterOutOldTokens(action.payload);
        default:
            return state;
    }
}

// Filtered it out in https://jira.raison.digital/browse/RAISON-4363
function filterOutOldTokens(assets: Assets) {
    return {
        ...assets,
        account: {
            ...assets.accounts,
            tokens: assets.accounts.tokens.filter(token => stablecoins.includes(token.currency)),
        },
    };
}

function error(state: null | unknown = null, action: AssetsAction): null | unknown {
    switch (action.type) {
        case assetsRequestRoutine.success.type:
            return null;
        case assetsRequestRoutine.failure.type:
            return action.payload;
        default:
            return state;
    }
}

function currentCurrency(
    state = (appLocalStorage.balanceCurrency.get() ?? 'EUR') as BaseCurrencyCode,
    action: ReturnType<typeof setCurrentCurrency>
): BaseCurrencyCode {
    switch (action.type) {
        case setCurrentCurrency.type:
            return action.payload;
        default:
            return state;
    }
}

export default combineReducers({
    fetching,
    assets,
    error,
    currentCurrency,
});
